export const projectsActivePageNumberKey = 'projectsActivePageNumber';
export const employeeProjectsActivePageNumberKey = 'employeeProjectsActivePageNumber';
export const employeesActivePageNumberKey = 'employeesActivePageNumber';
export const skillsActivePageNumberKey = 'skillsActivePageNumber';
export const employeeSkillsActivePageNumberKey = 'employeeSkillsActivePageNumber';


// WEBPACK FOOTER //
// ./src/constants/sessionStorageConstants.js